import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import AddEmployeeForm from './addemployee-form.js'
import AddEmployeeItemModel from '@/shared/models/business/employeemodel.js'

import CargoRepository from '@/shared/http/repositories/business/cargo.js'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import EmployeeBoardItemRepository from '@/shared/http/repositories/business/employeeboarditem.js'
import moment from 'moment'

export default {
  name: 'addemployee',
  mixins: [ ActionsForm ],
  data () {
    return {
      data: AddEmployeeItemModel,
      form: AddEmployeeForm,
      en: en,
      es: es,
      ptBR: ptBR,
      noSearch: false,
      objSelected: null
    }
  },
  components: {
    AutocompleteZ
  },
  computed: {
    RequestNumber () {
      let result = ''
      if (this.objSelected) {
        result = this.objSelected.pedido
      }
      return result
    },
    Responsible: function () {
      let result = ''
      if (this.objSelected && this.objSelected.responsavel) {
        result = this.objSelected.responsavel.codigo + '-' + this.objSelected.responsavel.nome
      }
      return result
    },
    ObraRH: function () {
      let result = ''
      if (this.objSelected && this.objSelected.obraRH) {
        result = this.objSelected.obraRH.nome
      }
      return result
    }
  },
  mounted () {
    this.form.refeicaoValorUnitario.value = 0
    this.form.valeAlimentacao.value = 0
    this.form.cafeManhaValor.value = 0
    this.form.valeTransporteValorUnitario.value = 0
    this.form.refeicaoQuantidade.value = 0
    this.form.valeTransporteQuantidade.value = 0
    this.$refs.employeeTypeahead.$refs.codeInput.focus()
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.$refs.employeeTypeahead.clear()
      this.form.refeicaoValorUnitario.value = 0
      this.form.valeAlimentacao.value = 0
      this.form.cafeManhaValor.value = 0
      this.form.valeTransporteValorUnitario.value = 0
      this.form.refeicaoQuantidade.value = 0
      this.form.valeTransporteQuantidade.value = 0
    },
    onBack () {
      this.$emit('Back')
    },
    onLoadFunction (cargoID) {
      loading.push()
      CargoRepository.GetById(cargoID)
        .then((response) => {
          let options = []
          options.push(response.data.data)
          response.data.data = options
          this.form.cargoID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSearchEmployee (value) {
      loading.push()
      EmployeeRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          this.$refs.employeeTypeahead.data = response.data.data
        })
        .catch((err) => {
          console.log(err)
        }).finally(() => loading.close())
    },
    onChangeCodeEmployee (value) {
      loading.push()
      EmployeeRepository.GetByCode(this.CompanySelected, value)
        .then(response => {
          if (response.data.code > 0) {
            this.$refs.employeeTypeahead.setValue(response.data.data)
            this.onLoadEmployee(response.data.data)
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => loading.close())
    },
    onLoadEmployee (data) {
      if (data) {
        let employee = data

        this.onLoadFunction(employee.cargoID)

        this.form.funcionario.value = employee
        this.form.nome.value = employee.nome
        this.data.funcionarioID = employee.id
        this.form.cargoID.value = employee.cargoID
        this.form.admissao.value = moment(employee.admissao).format('YYYY-MM-DD')

        const currentDate = moment()

        this.form.dataExperiencia1.value = currentDate.isSameOrBefore(employee.dataExperiencia2) ? moment(employee.dataExperiencia1).format('YYYY-MM-DD') : null
        this.form.dataExperiencia2.value = currentDate.isSameOrBefore(employee.dataExperiencia2) ? moment(employee.dataExperiencia2).format('YYYY-MM-DD') : null
        this.form.avisoPrevio.value = employee.avisoPrevio ? moment(employee.avisoPrevio).format('YYYY-MM-DD') : null
        // this.form.ferias.value = employee.ferias
        // this.form.inicioAfastamento.value =
      }
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.refeicaoQuantidade.value = parseInt(obj.refeicaoQuantidade)
      this.form.valeTransporteQuantidade.value = parseInt(obj.valeTransporteQuantidade)
      this.data.funcionarioID = obj.funcionarioID
      if (obj.funcionario) {
        this.form.cargoID.options = this.onSetDropdown([obj.funcionario.cargo])
        this.form.cargoID.value = obj.funcionario.cargoID
        this.$refs.employeeTypeahead.setValue(obj.funcionario)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.quadroFuncionarioID = this.objSelected.id
      this.data.empresaID = this.objSelected.empresaID

      EmployeeBoardItemRepository.Create(this.data)
        .then((response) => {
          if (response.data.code >= 0) {
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
          } else {
            loading.close()
            toast.error(response.data.message)
          }
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.quadroFuncionarioID = this.objSelected.id
      this.data.empresaID = this.objSelected.empresaID

      EmployeeBoardItemRepository.Update(this.data)
        .then((response) => {
          if (response.data.code >= 0) {
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
          }
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/board/components/addemployee/addemployee.js